// extracted by mini-css-extract-plugin
export default {"image-section-wrapper":"ComputedImage_image-section-wrapper__1hoee"};